module.exports = __webpack_public_path__ + "static/assets/65e3485313ec51b36185ff3412551c50.svg";